import React, { useEffect, useState } from "react";
import "./ProfileForm.scss";
import InputField from "../../UI/InputField/InputField";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import Radio from "../../UI/Radio/Radio";
import Button from "../../UI/Button/Button";
import InfoModal from "../../UI/InfoModal/InfoModal";
import DeviceContext from "../../Services/identifyDevice";
import { AGetEnumList, AGetKycDetails, AGetCityByPincode, ASaveNonIndAccount, AGetNonIndAccountDetails, AGetArea } from "../../Services/dashboard/profileApiService";
import { IListObj, ITokenObj } from "../../types/genericTypes";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import GlobalStore from "../../store/globalStore";
import { convertEnumIntoIObj, incompleteStageNavigation, capitalizeWords, completeModuleStatus } from "../../Services/globalService";
import AddressField, { IAddressFormat, addressErrorObj, CkycAddressFormat } from "../AddressField/AddressField";
import { useNavigate } from "react-router-dom";
import { repairAddressWithConditions } from "../../../components/utils/validation";
import Checkbox from "../../UI/Checkbox/Checkbox";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { dashboardUrl } from "../../utils/constants";
import gtmService from "../../Services/gtmService";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";

export interface ProfileFormProps { }

export const initialAddressObj: IAddressFormat = {
  addressLine1: "",
  City: "",
  Country: "",
  District: "",
  PinCode: "",
  State: "",
  Area: "",
  CountryCode: 0,
  StateCode: 0,
};

export const ckycAddressObj: CkycAddressFormat = {
  addressLine1: "",
  corrAddress: "",
  sameAsPermanent: true,
  city: "",
  country: "",
  district: "",
  pincode: "",
  corrPincode: "",
  state: "",
  area: "",
  countrycode: 0,
  statecode: 0,
};

const NonIndividualProfile: React.FC<ProfileFormProps> = () => {
  // Fetch query params for clervertap
  const navigate = useNavigate()
  let userId = "0";
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = tokenMainObj?.UserId?.toString();
  }

  const [occupationList, setOccupationList] = React.useState<Array<IListObj>>([]);
  const [incomeList, setIncomeList] = React.useState<Array<IListObj>>([]);
  const [areaList, setAreaList] = React.useState<Array<IListObj>>([]);
  const [corrAreaList, setCorrAreaList] = React.useState<Array<IListObj>>([]);
  const [KAccType, setKAccType] = React.useState<Array<IListObj>>([]);

  const [errors, setErrors] = React.useState<{ [key: string]: string | undefined; }>({});
  const [errCode, setErrCode] = React.useState<number | string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [showExplain, setShowExplain] = React.useState<boolean>(false);
  const [sameAsPermanent, setSameAsPermanent] = React.useState<boolean>(true);

  const [compFirmName, setCompFirmName] = React.useState<string>(GlobalStore.nonIndFullName);
  const [permanentAddress, setPermanentAddress] = React.useState<IAddressFormat>({ ...initialAddressObj });
  const [correspondanceAddress, setCorrespondanceAddress] = React.useState<IAddressFormat>({ ...initialAddressObj });
  const [permErrorObj, setPermErrorObj] = React.useState<{
    [key in keyof IAddressFormat]?: string;
  }>({
    ...addressErrorObj,
  });
  const [corrErrorObj, setCorrErrorObj] = React.useState<{
    [key in keyof IAddressFormat]?: string;
  }>({
    ...addressErrorObj,
  });
  const [politicalVal, setPoliticalVal] = React.useState<"0" | "1" | "2">("0");
  const [annualIncome, setAnnualIncome] = React.useState<string>("");
  const [netWorth, setNetWorth] = React.useState<string>("");
  const [POAType, setPOAType] = React.useState(true);
  const [occupation, setOccupation] = React.useState<string>("");
  const [kAccTypeValue, setKAccTypeValue] = React.useState<string>("1");

  React.useEffect(() => {
    setIsLoading(true);
    AGetNonIndAccountDetails(getKycDetails, GlobalStore.applicationID);
    AGetEnumList(getEnumList, "");
    AGetEnumList(getAnnualIncomeList, "grossannualincrange");
  }, []);

  React.useEffect(() => {
    if (permanentAddress?.PinCode?.length >= 6)
      AGetArea(getAreaList, permanentAddress.PinCode);
  }, [permanentAddress.PinCode]);

  React.useEffect(() => {
    if (correspondanceAddress?.PinCode?.length >= 6)
      AGetArea(getCorrAreaList, correspondanceAddress.PinCode);
  }, [correspondanceAddress.PinCode]);

  const shouldDisable = () => {
    let disabled: boolean = false;
    if (
      GlobalStore?.stageStatus?.first_esign_initiated !== null &&
      GlobalStore?.stageStatus?.first_esign_initiated !== undefined &&
      GlobalStore?.stageStatus?.first_esign_initiated
    ) {
      disabled = true;
    }
    return disabled;
  };

  function getEnumList(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data && res.data.enumlist && res.data.enumlist.length > 0) {
        let [
          occupationList,
          KAccType
        ] = convertEnumIntoIObj(res.data.enumlist, [
          "OccupationCode",
          "KAccType"
        ]);
        setOccupationList(occupationList);
        setKAccType(KAccType);
      }
    }
    setIsLoading(false);
  }

  function getAnnualIncomeList(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data && res.data.enumlist && res.data.enumlist.length > 0) {
        let [
          incomeList,
        ] = convertEnumIntoIObj(res.data.enumlist, [
          "GrossAnnualIncRange",
        ]);
        incomeList = fixIncomeList(incomeList);
        setIncomeList(incomeList);
      }
    }
    setIsLoading(false);
  }

  function getClientStageDetails(res: any) {
    const data = JSON.parse(res.data)
    setCompFirmName(capitalizeWords(data.compfirmname.replace(/[!@#$%^&*()]/g, '')))
    window.sessionStorage.setItem("clientName", data.compfirmname)
  }

  useEffect(() => {
    window.sessionStorage.setItem("clientName", compFirmName)
  }, [compFirmName])

  function fixIncomeList(list: IListObj[]) {
    return list.map((e) => ({ ...e, display: e.display.replace("Btw ", "") }));
  }

  function getCorrAddress(res: any, address: string) {
    if (!res || res.error) {
      setErrCode(res.error);
      setErrCode(res.error);
    } else {
      if (res.data && res.data.length > 0) {
        let obj: any = {};
        obj.PinCode = res.data[0].PinCode;
        obj.District = res.data[0].District;
        obj.Country = res.data[0].Country;
        obj.City = res.data[0].City;
        obj.State = res.data[0].State;
        obj.StateCode = res.data[0].StateCode;
        obj.CountryCode = res.data[0].CountryCode;
        obj.addressLine1 = address;
        setCorrespondanceAddress(obj);
        setIsLoading(false);
      }
    }
  }

  function getFullAddress(res: any, sameAsPerman?: boolean) {
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data && res.data.length > 0) {
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        let obj: any = {};
        obj.PinCode = res.data[0].PinCode;
        obj.District = res.data[0].District;
        obj.Country = res.data[0].Country;
        obj.City = res.data[0].City;
        obj.State = res.data[0].State;
        obj.StateCode = res.data[0].StateCode;
        obj.CountryCode = res.data[0].CountryCode;
        obj.addressLine1 = clientPartialDetails_ao.addressLine1
          ? clientPartialDetails_ao.addressLine1
          : GlobalStore.ckycInfoObject.addressLine1
            ? GlobalStore.ckycInfoObject.addressLine1
            : GlobalStore.kraInfoObject.addressLine1
              ? GlobalStore.kraInfoObject.addressLine1
              : GlobalStore.personaldetails.addressLine1;
        setPermanentAddress(obj);
        const areaObj = {
          pincode: res.data[0].PinCode,
          city: res.data[0].City,
          state: res.data[0].State,
        };
        if (
          sameAsPerman !== null && sameAsPerman !== undefined
            ? sameAsPerman
            : sameAsPermanent
        ) {
          setCorrespondanceAddress(obj);
          setIsLoading(false);
        } else {
          if (clientPartialDetails_ao.corrPincode) {
            AGetCityByPincode((res: any) =>
              getCorrAddress(res, clientPartialDetails_ao.corrAddress), GlobalStore.ckycInfoObject.pincode
            );
          } else setIsLoading(false);
        }
      } else {
        setErrCode(res.error);
      }
    }
  }

  async function getKycDetails(res: any) {
    try {
      setIsLoading(true);
      if (!res || res.error) {
        setIsLoading(false);
        setErrCode(res.error);
      } else {
        if (res.data) {
          let responseObj = JSON.parse(res.data);
          if (!responseObj.personalDetails)
            AGetStageCompletionStatus(getClientStageDetails, GlobalStore.applicationID);
          if (responseObj.permanentAddressDetails && responseObj.correspondenceAddressDetails) {
            if (responseObj.permanentAddressDetails) {
              let resultObj = responseObj.permanentAddressDetails;
              const permAddObj = { ...permanentAddress };
              permAddObj.addressLine1 = resultObj.permanentaddress
              permAddObj.PinCode = resultObj.permanentpincode;
              permAddObj.Country = resultObj.permanentcountry;
              permAddObj.State = resultObj.permanentstate;
              permAddObj.City = resultObj.permanentcity;
              permAddObj.District = resultObj.permanentdistrict;
              permAddObj.Area = resultObj.permanentArea;
              permAddObj.StateCode = resultObj.permanentstatecode;
              permAddObj.CountryCode = resultObj.permanentcountrycode;
              setPermanentAddress(permAddObj);
            }
            if (responseObj.correspondenceAddressDetails) {
              let resultObj = responseObj.permanentAddressDetails;
              const corrAddObj = { ...correspondanceAddress };
              corrAddObj.addressLine1 = resultObj.correspondenceaddress;
              corrAddObj.PinCode = resultObj.correspondencepincode;
              corrAddObj.Country = resultObj.correspondencecountry;
              corrAddObj.State = resultObj.correspondencestate;
              corrAddObj.City = resultObj.correspondencecity;
              corrAddObj.District = resultObj.correspondencedistrict;
              corrAddObj.Area = resultObj.correspondencearea;
              corrAddObj.StateCode = resultObj.correspondencestatecode;
              corrAddObj.CountryCode = resultObj.correspondencecountrycode;
              setCorrespondanceAddress(corrAddObj);
            }
            if (responseObj.personalDetails) {
              let resultObj = responseObj.personalDetails
              setCompFirmName(resultObj.compfirmname || GlobalStore.nonIndFullName)
              // GlobalStore.entityType = resultObj.entitytype
              GlobalStore.isKRA = resultObj.isKRA;
              setSameAsPermanent(resultObj.iscorressaddressaspermanent)
            }
            if (responseObj.ProfileDetails) {
              let resultObj = responseObj.ProfileDetails
              setPOAType(!resultObj.taxresidentofothercountry)
              setAnnualIncome(resultObj.annualincomerange)
              setNetWorth(resultObj.networthwhenacopen)
              setPoliticalVal(resultObj.pep)
            }
          }
          else {
            const clientPartialDetails_ao = JSON.parse(
              window.localStorage.getItem("clientPartialDetails_ao") || "{}"
            );
            let pinCode: string = "";

            if (clientPartialDetails_ao.pincode) {
              pinCode = clientPartialDetails_ao.pincode;
            }
            else if (
              GlobalStore.isKRA &&
              GlobalStore.kraInfoObject.addressLine1 &&
              GlobalStore.kraInfoObject.pincode
            )
              pinCode = GlobalStore.kraInfoObject.pincode;
            else if (
              GlobalStore.isKYC &&
              GlobalStore.ckycNo !== "" &&
              GlobalStore.ckycInfoObject.addressLine1 &&
              GlobalStore.ckycInfoObject.pincode
            )
              pinCode = GlobalStore.ckycInfoObject.pincode;
            else if (
              GlobalStore.isDigiLocker &&
              GlobalStore.personaldetails.addressLine1 &&
              GlobalStore.personaldetails.pincode
            )
              pinCode = GlobalStore.personaldetails.pincode;
            if (
              clientPartialDetails_ao.sameAsPermanent !== null &&
              clientPartialDetails_ao.sameAsPermanent !== undefined &&
              clientPartialDetails_ao.sameAsPermanent &&
              clientPartialDetails_ao.corrPincode
            ) {
              AGetCityByPincode((res: any) =>
                getCorrAddress(res, clientPartialDetails_ao.corrAddress),
                clientPartialDetails_ao.corrPincode
              );
            }
            if (pinCode !== null && pinCode !== undefined && pinCode !== "") {
              AGetCityByPincode(getFullAddress, pinCode);
            }
          }
        }
      }
    } catch (error) {
      console.log("error in catch", error);
    }
  }

  function getAreaList(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data && res.data.areas) {
        const arr: Array<IListObj> = [];
        res.data.areas.forEach((item: string) => {
          let obj: IListObj = {
            value: item,
            display: item,
          };
          arr.push(obj);
        });
        setAreaList(arr);
      } else {
        setErrCode("130 - Failed to fetch the area list for the pincode");
      }
    }
    setIsLoading(false);
  }

  function getCorrAreaList(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res.data && res.data.areas) {
        const arr: Array<IListObj> = [];
        res.data.areas.forEach((item: string) => {
          let obj: IListObj = {
            value: item,
            display: item,
          };
          arr.push(obj);
        });
        setCorrAreaList(arr);
      } else {
        setErrCode("130 - Failed to fetch the area list for the pincode");
      }
    }
    setIsLoading(false);
  }

  function handleSameAsAbove(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.name === "sameAscorrespondance") {
      if (event.target.checked) {
        setCorrespondanceAddress({ ...permanentAddress })
        setCorrErrorObj({})
      }
      setSameAsPermanent(!sameAsPermanent)
    }
  }

  function dropDownBlur(key: string, value: any) {
    typeof value !== "object"
      ? setErrors({ ...errors, [key]: errorMsg(errorCode.FE20) })
      : setErrors({ ...errors, [key]: undefined });
  }

  function validateSubmit(): boolean {
    return getValidationErrors() !== null;
  }

  function getValidationErrors(): string | null {
    const checks: [boolean, string][] = [
      [!compFirmName, "Company Name is required"],
      [Object.values(permErrorObj).some(e => e), "Permanent address has errors"],
      [Object.values(corrErrorObj).some(e => e), "Correspondence address has errors"],
      [Object.values(permanentAddress).some(v => !v), "Permanent address fields are missing"],
      [Object.values(correspondanceAddress).some(v => !v), "Correspondence address fields are missing"],
      // [!netWorth, "Net worth is required"],
      [parseInt(netWorth) < 1000, "Net worth must be more than 1000"],
      [!annualIncome, "Annual income is required"],
      [Object.values(errors).some(e => e), "There are general form errors"],
    ];

    const failedCheck = checks.find(([condition]) => condition);
    return failedCheck ? failedCheck[1] : null;
  }

  const removeSpclCracters = (value: string) => {
    if (value) {
      return value; //.replace(/[^a-zA-Z0-9 ]/g, " ");
    } else {
      return "";
    }
  };

  async function handleSubmit() {
    setIsLoading(true);
    const correspondanceAddressLine = repairAddressWithConditions(
      correspondanceAddress.addressLine1,
      correspondanceAddress.City
    );
    const permanentAddressLine = repairAddressWithConditions(
      permanentAddress.addressLine1,
      permanentAddress.City
    );

    const kycObj: any = {
      leadId: GlobalStore.leadId,
      clientPrimaryDetailID: GlobalStore.clientPrimaryDetailId,
      applicationID: GlobalStore.applicationID,
      personalDetails: {
        compFirmName: compFirmName,
        entityType: GlobalStore.entitySubType,
        isKRA: GlobalStore.isKRA,
        isCorressAddressAsPermanent: sameAsPermanent,
        incorporationDate: GlobalStore.dateOfIncorporation,
        kraEmail: GlobalStore.KRA_email ? GlobalStore.KRA_email : "",
        kraMobile: GlobalStore.KRA_mobile ? GlobalStore.KRA_mobile : "",
      },
      profileDetails: {
        taxResidentOfOtherCountry: !POAType,
        annualIncomeRange: annualIncome,
        netWorthWhenAcOpen: netWorth,
        pep: politicalVal,
        businessType: "Export"
      },
      correspondenceAddressDetails: {
        correspondenceAddress: `
            ${removeSpclCracters(correspondanceAddressLine.addLine1) || ""},  
            ${removeSpclCracters(correspondanceAddressLine.addLine2) || ""}, 
            ${removeSpclCracters(correspondanceAddressLine.addLine3) || ""},
            ${removeSpclCracters(correspondanceAddressLine.addLine4) || ""}
          `,
        correspondencePincode: correspondanceAddress.PinCode,
        correspondenceCountry: correspondanceAddress.Country,
        correspondenceState: correspondanceAddress.State,
        correspondenceCity: correspondanceAddress.City,
        correspondenceDistrict: correspondanceAddress.District,
        correspondenceArea: correspondanceAddress.Area || "",
        correspondenceStatecode: Number(correspondanceAddress.StateCode),
        correspondenceCountryCode: Number(correspondanceAddress.CountryCode),
      },
      permanentAddressDetails: {
        permanentAddress: `
            ${removeSpclCracters(permanentAddressLine.addLine1) || ""},  
            ${removeSpclCracters(permanentAddressLine.addLine2) || ""}, 
            ${removeSpclCracters(permanentAddressLine.addLine3) || ""},
            ${removeSpclCracters(permanentAddressLine.addLine4) || ""}
          `,
        permanentPincode: permanentAddress.PinCode,
        permanentCountry: permanentAddress.Country,
        permanentState: permanentAddress.State,
        permanentCity: permanentAddress.City,
        permanentDistrict: permanentAddress.District,
        permanentArea: permanentAddress.Area,
        permanentcountrycode: Number(permanentAddress.CountryCode),
        permanentstatecode: Number(permanentAddress.StateCode),
      },
    };
    ASaveNonIndAccount(saveKycDetails, kycObj);
  }

  function saveKycDetails(res: any) {
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data) {
        completeModuleStatus(dashboardUrl.profile);
        completeModuleStatus(dashboardUrl.personalIfo);
        gtmService({ action: "PROFILE_DETAILS", label: "Step_Complete" });
        navigate(incompleteStageNavigation())
      } else {
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  }

  function ChangePoliticalVal(Value: any) {
    setPoliticalVal(Value);
    setErrCode("");
    errorMsg("");
  }

  const validationErrors = getValidationErrors();

  return (
    <div className={"profileForm " + (isLoading ? " op05" : "")}>
      <label className="prflFormHeading">Primary Details</label>
      <form>
        <fieldset disabled={isLoading}>
          <div className="mgt40">
            <label className="fieldLbl">Name (according to PAN)</label>
            <InputField
              required
              alphabate
              defaultValue={compFirmName}
              // onBlur={(error) =>
              //   setErrors({
              //     ...errors,
              //     compFirmName: error.required
              //       ? errorMsg(errorCode.FE33)
              //       : "",
              //   })
              // }
              onChange={(val) =>
                setCompFirmName(capitalizeWords(val))
              }
              errorText={errors.compFirmName}
              placeholder="Khandelwal Groups"
              type="text"
              disabled={compFirmName ? true : false}
            />
          </div>
          <div className="mgt40">
            <label className="fieldLbl">
              Entity Type
            </label>
            <DropdownSearch
              name="KAccTypeValue"
              defaultValue={
                GlobalStore.entitySubType ||
                KAccType?.find((item) => item.value == kAccTypeValue)
                  ?.display
              }
              onOptionSelect={(val) =>
                setKAccTypeValue(val["value"] as string)
              }
              searchLength={0}
              options={KAccType}
              // onBlur={(val) => dropDownBlur("KAccTypeValue", val)}
              searchKey="display"
              placeholder="Select Your Acc"
              // noDataMsg="Occupation with similar name not found"
              // errorText={errors.occupation}
              isDownArrow={true}
              disabled={true}
            />
          </div>
          <AddressField
            addressObj={permanentAddress}
            sectionLabel="Permanent Address"
            addressType="permanent"
            setErrCode={setErrCode}
            onAddressChange={(obj: IAddressFormat) => {
              setPermanentAddress(obj);
              sameAsPermanent && setCorrespondanceAddress(obj);
            }}
            onAddressBlur={setPermErrorObj}
            handleSameAsAbove={handleSameAsAbove}
            enableCity={permanentAddress?.City ? false : true}
            addressTitle="Corporate Address"
            isDisable={permanentAddress?.addressLine1 ? true : false}
          />
          <div className="mgt40">
            <label className="fieldLbl">
              Area
            </label>
            <DropdownSearch
              name={`area`}
              defaultValue={
                // areaList.find((item) => item.value === permanentAddress.Area)
                //   ?.display
                permanentAddress.Area
              }
              onOptionSelect={(val) => {
                const permAddObj = { ...permanentAddress }
                permAddObj.Area = val["value"] as string
                setPermanentAddress(permAddObj)
              }}
              searchLength={0}
              options={areaList}
              onBlur={(val) => dropDownBlur("area", val)}
              searchKey="display"
              placeholder="Eg. Thane"
              noDataMsg="Area with similar name not found"
              errorText={errors.area}
              isDownArrow={true}
              disabled={permanentAddress.Area ? true : false}
            />
          </div>

          {/* Correspondence Address Start */}
          <AddressField
            addressObj={correspondanceAddress}
            sectionLabel="Correspondence Address"
            addressType="correspondance"
            setErrCode={setErrCode}
            onAddressChange={setCorrespondanceAddress}
            onAddressBlur={setCorrErrorObj}
            showSameAsAbove
            sameAsAbove={sameAsPermanent}
            handleSameAsAbove={handleSameAsAbove}
            enableCity={true}
            addressTitle="Corporate Address"
          />
          {!sameAsPermanent &&
            <div className="mgt40">
              <label className="fieldLbl">
                Area
              </label>
              <DropdownSearch
                name={`corrArea`}
                defaultValue={correspondanceAddress.Area}
                onOptionSelect={(val) => {
                  const permAddObj = { ...correspondanceAddress }
                  permAddObj.Area = val["value"] as string
                  setCorrespondanceAddress(permAddObj)
                }}
                searchLength={0}
                options={corrAreaList}
                onBlur={(val) => dropDownBlur("corrArea", val)}
                searchKey="display"
                placeholder="Eg. Thane"
                noDataMsg="Area with similar name not found"
                errorText={errors.corrArea}
                isDownArrow={true}
              />
            </div>
          }
          {/* Correspondence Address End */}

          <div className="mgt80">
            <label className="prflFormHeading">Business Details</label>
          </div>
          <div className="mgt40">
            <label className="fieldLbl">Business Type</label>
            <DropdownSearch
              name="occupation"
              defaultValue={
                occupationList.find((item) => item.value === occupation)
                  ?.display
              }
              onOptionSelect={(val) =>
                setOccupation(val["value"] as string)
              }
              searchLength={0}
              options={occupationList}
              onBlur={(val) => dropDownBlur("occupation", val)}
              searchKey="display"
              placeholder="Select Your Occupation"
              noDataMsg="Occupation with similar name not found"
              errorText={errors.occupation}
              isDownArrow={true}
            />
          </div>
          <div className="mgt40">
            <label className="fieldLbl">Politically Exposed Person</label>
            <div className="fieldLblRight">
              <div className="explain">
                <label
                  className="explainLbl"
                  onMouseOver={() => setShowExplain(true)}
                  onMouseLeave={() => setShowExplain(false)}
                >
                  Explain
                </label>
                {showExplain && (
                  <InfoModal
                    width={DeviceContext().isMobile ? "328px" : "354px"}
                  >
                    <div className="explainInfo">
                      <label>
                        A Politically Exposed Person (PEP) is a person who
                        can potentially be influenced by political parties
                        directly or indirectly.
                      </label>
                    </div>
                  </InfoModal>
                )}
              </div>
            </div>
          </div>
          <div className="mgt20">
            <Radio
              checked={politicalVal === "1"}
              onChange={() => ChangePoliticalVal("1")}
              name="politicalParty"
              label="I am a Politically Exposed Person"
            //disabled={true}
            />
            <Radio
              className="mgt14"
              checked={politicalVal === "2"}
              onChange={() => ChangePoliticalVal("2")}
              name="politicalParty"
              label="I am Related to Politically Exposed Person"
            //disabled={true}
            />
            <Radio
              className="mgt14"
              checked={politicalVal === "0"}
              onChange={() => ChangePoliticalVal("0")}
              name="politicalParty"
              label="None"
            />
          </div>
          <div className="mgt40">
            <label className="fieldLbl">Business's Annual Income</label>
            <DropdownSearch
              name="annualIncome"
              defaultValue={
                incomeList.find((item) => item.value === annualIncome)
                  ?.display
              }
              onOptionSelect={(val) =>
                setAnnualIncome(val["value"] as string)
              }
              searchLength={0}
              options={incomeList}
              searchKey="display"
              placeholder="Select Your Annual Income Bracket"
              noDataMsg="Annual Income with similar name not found"
              errorText={errors.annualIncome}
              onBlur={(val) => dropDownBlur("annualIncome", val)}
              isDownArrow={true}
            />
          </div>
          <div className="mgt40">
            <label className="fieldLbl">Net Worth (Optional)</label>
            <InputField
              integer
              // required
              maxLength={9}
              min={1001}
              defaultValue={netWorth}
              // onBlur={(error) =>
              //   setErrors({
              //     ...errors,
              //     netWorth:
              //       error.required || error.min
              //         ? // ? 'Please Enter Amount More Than Rs 1000'
              //         errorMsg(errorCode.FE22)
              //         : "",
              //   })
              // }
              errorText={errors.netWorth}
              onChange={(val) => setNetWorth(val)}
              placeholder="Eg. 30,00,000"
            // helpText='Maximum 100 Cr.'
            />
          </div>
          {GlobalStore.entitySubType == "HUF" &&
            <div className="mgt40">
              <div className="termList mrt41">
                <Checkbox
                  checked={POAType}
                  name="defaultSetting"
                  onChange={() => setPOAType(!POAType)}
                />
                <label className="mrl13 linkLabel">
                  I am a tax resident of India and not a resident of any other
                  country. Auto selected and read only
                </label>
              </div>
            </div>
          }
          <br></br>

          {errCode && politicalVal == "0" && (
            <div className="errMsgBlck">
              <ErrMsg>
                <label>{errCode}</label>
              </ErrMsg>
            </div>
          )}
          {errCode && politicalVal != "0" && (
            <div className="errMsgBlck">
              <ErrMsg>
                <label>{errCode}</label>
              </ErrMsg>
            </div>
          )}
          {validationErrors && (
            <div className="errMsgBlck">
              <ErrMsg>{validationErrors}</ErrMsg>
            </div>
          )}
          {/* Error Msg End*/}
          <div className="mgt40">
            <Button
              type="submit"
              btnName="Submit"
              isLoading={isLoading}
              onClick={handleSubmit}
              disabled={
                shouldDisable() ||
                (errCode && politicalVal != "0") ||
                validateSubmit()
              }
            />
          </div>
        </fieldset>
      </form>
    </div>
  );
};

export default NonIndividualProfile;
